"use client";

import { createContext, useContext, ReactNode } from "react";

type OrgContextType = {
  orgId: string;
  orgSlug: string;
};

const OrgContext = createContext<OrgContextType | null>(null);

export function OrgProvider({
  orgId,
  orgSlug,
  children,
}: OrgContextType & { children: ReactNode }) {
  return (
    <OrgContext.Provider value={{ orgId, orgSlug }}>
      {children}
    </OrgContext.Provider>
  );
}

export function useOrg() {
  const context = useContext(OrgContext);
  if (!context) {
    throw new Error("useOrg must be used within an OrgProvider");
  }
  return context;
}

export function useOrgOptional() {
  return useContext(OrgContext);
}
